'use client';

import { useFeatureFlagEnabled } from 'posthog-js/react';

import { FEATURE_FLAGS } from './feature-flagging.consts';

export default function usePosthogFeatureFlag(
  flagKey: keyof typeof FEATURE_FLAGS | (string & {}),
  initialValue?: boolean
) {
  const result = useFeatureFlagEnabled(flagKey);
  const isLoaded = result !== undefined;
  const isEnabled = result ?? initialValue ?? false;

  const flag = <T, F = null>(value: T, fallback?: F): T | F | null =>
    isEnabled ? value : (fallback ?? null);

  return { flag, loading: !isLoaded };
}
